import React, {Fragment, useState} from "react";

import {Divider} from "@mui/material";
import {Grid} from "@mui/system";

import {
  CargoItems,
  GeneralLoadInfo,
  HouseInfo,
  NcmField,
  HouseInfoIA,
  HouseMeasurements,
  LoadEquipment,
  MasterInfo,
  MasterInfoIA,
  ModalAddNcm,
  NcmList,
} from "./components";
import pxToRem from "hooks/usePxToRem";
import {useFormContext} from "react-hook-form";
import {ProcessBillLadingNcm} from "views/ProcessDetails/Process.types";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import getModalityAndOperation from "util/getModalityAndOperation";

type Props = {
  refetchProcess: () => Promise<Process | undefined>;
};

const ProcessLoad = (props: Props) => {
  const {refetchProcess} = props;
  const [isModalAddNcmOpen, setIsModalAddNcmOpen] = useState(false);

  const handleOpenModalAddNcm = () => setIsModalAddNcmOpen(true);
  const handleCloseModalAddNcm = () => setIsModalAddNcmOpen(false);

  const {watch, getValues} = useFormContext<Process>();

  const [ncmsTableData, setNcmsTableData] = useState<ProcessBillLadingNcm[]>(
    watch("processBillLadingNcms"),
  );

  // Considerando que sempre teremos apenas 1 carga no projeto.
  const LOAD_INDEX = 0;
  const isIAProcess =
    getModalityAndOperation(getValues("modality"), getValues("operation"))
      .short === "IA";

  return (
    <Fragment>
      {isModalAddNcmOpen && (
        <ModalAddNcm
          isModalOpen={isModalAddNcmOpen}
          onRequestCloseModal={handleCloseModalAddNcm}
          refetchProcess={refetchProcess}
          setNcmsTableData={setNcmsTableData}
        />
      )}
      <GeneralLoadInfo />
      {watch("processLoads.0.typeLoad") === "FCL" && (
        <LoadEquipment refetchProcess={refetchProcess} />
      )}
      <Grid container columnSpacing={pxToRem(20)}>
        {isIAProcess && (
          <>
            <Grid size={6}>
              <MasterInfoIA />
            </Grid>

            <Grid size={6}>
              <HouseInfoIA />
            </Grid>
          </>
        )}
        {!isIAProcess && (
          <>
            <Grid size={12}>
              <MasterInfo />
            </Grid>

            <Grid size={12}>
              <HouseInfo />
            </Grid>
          </>
        )}

        <Grid size={12}>
          <HouseMeasurements loadIndex={LOAD_INDEX} />
        </Grid>
      </Grid>
      <Grid size={12} mt={pxToRem(8)} mb={pxToRem(8)}>
        <Divider />
      </Grid>

      <CargoItems loadIndex={LOAD_INDEX} />

      {!isIAProcess && (
        <NcmList
          onRequestOpenModalAddNcm={handleOpenModalAddNcm}
          refetchProcess={refetchProcess}
          ncmsTableData={ncmsTableData}
          setNcmsTableData={setNcmsTableData}
        />
      )}

      {isIAProcess && (
        <NcmField loadIndex={LOAD_INDEX} />
      )}
    </Fragment>
  );
};

export default React.memo(ProcessLoad);
